import {
  HostListener,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss'],
})
export class FaqsComponent implements OnInit {
  showMsg: boolean = false;
  nextElementSibling: any;

  @HostListener('click', ['$event.target'])
  onClick(btn: any) {
    // console.log('button', btn);
  }

  aboutFaq = [
    {
      icon: '../../../../assets/img/icon2.png',
      title: 'About HuiosPay',
      desc: 'Learn everything about HuiosPay',
    },
    {
      icon: '../../../../assets/img/icon2.png',
      title: 'About our POS',
      desc: 'Learn everything you need to know about HuiosPay POS',
    },
    {
      icon: '../../../../assets/img/icon2.png',
      title: 'About Payments',
      desc: 'Learn everything you need to know about making payments with HuiosPay',
    },
    {
      icon: '../../../../assets/img/icon2.png',
      title: 'About our APIs & Integration',
      desc: 'Learn everything about HuiosPay APIs and how to integrate them',
    },
  ];

  faq = [
    {
      id: 1,
      question: 'Section 1',
      answer:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquipea commodo consequat.',
    },
    {
      id: 2,
      question: 'Section 2',
      answer:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquipea commodo consequat.',
    },
    {
      id: 3,
      question: 'Section 3',
      answer:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquipea commodo consequat.',
    },
    {
      id: 4,
      question: 'Section 4',
      answer:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquipea commodo consequat.',
    },
  ];

  recentActivity = [
    {
      badge: 'Manage Account',
      title: 'How can I set up my Merchant account?',
      faq: 'What documents do I need to complete my application?',
      createdAt: 'Article created 2 days ago',
    },
    {
      badge: 'Manage Account',
      title: 'How can I set up my Merchant account?',
      faq: 'What documents do I need to complete my application?',
      createdAt: 'Article created 2 days ago',
    },
    {
      badge: 'Manage Account',
      title: 'How can I set up my Merchant account?',
      faq: 'What documents do I need to complete my application?',
      createdAt: 'Article created 2 days ago',
    },
    {
      badge: 'Manage Account',
      title: 'How can I set up my Merchant account?',
      faq: 'What documents do I need to complete my application?',
      createdAt: 'Article created 2 days ago',
    },
    {
      badge: 'Manage Account',
      title: 'How can I set up my Merchant account?',
      faq: 'What documents do I need to complete my application?',
      createdAt: 'Article created 2 days ago',
    },
    {
      badge: 'Manage Account',
      title: 'How can I set up my Merchant account?',
      faq: 'What documents do I need to complete my application?',
      createdAt: 'Article created 2 days ago',
    },
    {
      badge: 'Manage Account',
      title: 'How can I set up my Merchant account?',
      faq: 'What documents do I need to complete my application?',
      createdAt: 'Article created 2 days ago',
    },
    {
      badge: 'Manage Account',
      title: 'How can I set up my Merchant account?',
      faq: 'What documents do I need to complete my application?',
      createdAt: 'Article created 2 days ago',
    },
    {
      badge: 'Manage Account',
      title: 'How can I set up my Merchant account?',
      faq: 'What documents do I need to complete my application?',
      createdAt: 'Article created 2 days ago',
    },
  ];

  constructor() {}

  toggleAccord() {
    var acc = document.getElementsByClassName('accordion');
    console.log(acc);
    var i: any;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener('click', () => {});

      // this.classList.toggle("active");
      //   var panel = this.nextElementSibling;
      //   if (panel.style.display === "block") {
      //     panel.style.display = "none";
      //   } else {
      //     panel.style.display = "block";
      //   }
      // });
    }
  }

  status(event: any){
    console.log('clicked id', event);
    this.showMsg = true;
    

  }

  ngOnInit(): void {
    this.toggleAccord();
  }
}
